import React from 'react';
import { FiPhone } from 'react-icons/fi';

const PhoneSegment = ({ phone, onPhoneChange, phoneError, onFocus }) => {
  return (
    <div className={`sf-searchbar__segment sf-searchbar__segment--phone ${phoneError ? 'sf-searchbar__segment--error' : ''}`}>
      <span className="sf-searchbar__segment-icon">
        <FiPhone />
      </span>
      <div className="sf-searchbar__segment-text">
        <label className="sf-searchbar__segment-label">TELÉFONO</label>
        <input
          type="tel"
          className="sf-searchbar__segment-value sf-searchbar__segment-input"
          placeholder="+1 234 567 890"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          onFocus={onFocus}
        />
      </div>
    </div>
  );
};

export default PhoneSegment;
